<script>
import InputPrice from '@/plugins/form/__components/InputPrice.vue';
import object from "@/utils/object";

export default {
  components: {
    InputPrice,
  },
  props: {
    sourceServicePrices: {
      type: Array,
    },
    serviceClassId: {
      type: Number,
    },
  },
  methods: {
    addHotelPrice(price) {
      const isDefault = price.HotelServicePrices.filter(i => i.IsDefault).length == 0;
      price.HotelServicePrices.push({
        Id: 0,
        RoomTypeId: 0,
        RoomAccomodationId: 0,
        BoardingId: 0,
        IsDefault: isDefault,
        Netto: 0,
        AgentPrice: 0,
        ClientPrice: 0,
        Quota: 0
      });
    },
    removeHotelPrice(price, hotelPrice) {
      const index = price.HotelServicePrices.indexOf(hotelPrice);
      if (index > -1) {
        price.HotelServicePrices.splice(index, 1);
      }
    },
    getName(price){
      return price.tariff.IsDefault
        ? ""
        : `Стоимость тарифа: ${price.tariff.Netto}/${price.tariff.Brutto - price.tariff.Charge}/${price.tariff.Brutto}`
    },
    labelName(price){
      return price.tariff.IsDefault
        ? ""
        : price.tariff.Name
    }
  },
  mounted() {
    fetch('/tourclient/masterAgent/dictionary/roomType/list',
      {method: 'POST', body: new URLSearchParams({request: JSON.stringify({})})})
      .then(resp => resp.json())
      .then(json => {
        this.roomTypes = json.Items;
      });

    fetch('/tourclient/masterAgent/dictionary/roomAccomodation/list',
      {method: 'POST', body: new URLSearchParams({request: JSON.stringify({})})})
      .then(resp => resp.json())
      .then(json => {
        this.roomAccomodations = json.Items;
      });

    fetch('/tourclient/masterAgent/dictionary/boarding/list',
      {method: 'POST', body: new URLSearchParams({request: JSON.stringify({})})})
      .then(resp => resp.json())
      .then(json => {
        this.boarings = json.Items;
      });
  },
  data() {
    return {
      roomTypes: [],
      roomAccomodations: [],
      boarings: [],
      servicePrices: this.sourceServicePrices,
    };
  }
};
</script>
<template>
  <RowSpan v-if="servicePrices && servicePrices.length">
    <ColGroup v-for="price in servicePrices" :label="labelName(price)" v-bind:key="price.tariff.TariffId" v-if="price.isShow">
      {{getName(price)}}
   <el-form class="hotel-service-form">
     <div class="checkbox-group">
      <el-form-item label="Услуга включена в стоимость">
        <el-checkbox v-model="price.IncludeInCost"></el-checkbox>
      </el-form-item>
      <el-form-item label="Групповая услуга">
        <el-checkbox v-model="price.IsGroupService"></el-checkbox>
      </el-form-item>
      <el-form-item label="Комиссионная услуга">
        <el-checkbox v-model="price.IsCommissionService"></el-checkbox>
      </el-form-item>
      <el-form-item v-if="serviceClassId === 3" label="Детализация цен">
        <el-checkbox v-model="price.HasVariants"></el-checkbox>
      </el-form-item>
    </div>
    <div v-if="!price.HasVariants" class="price-group">
      <el-form-item label="Себестоимость">
        <el-input v-model="price.Netto"></el-input>
      </el-form-item>
      <el-form-item label="Для агента">
        <el-input v-model="price.AgentPrice"></el-input>
      </el-form-item>
      <el-form-item label="Для клиента">
        <el-input v-model="price.ClientPrice"></el-input>
      </el-form-item>
    </div>
    <div v-else-if="serviceClassId === 3">
      <el-table :data="price.HotelServicePrices" width="100%">
        <el-table-column width="100" label="">
          <template slot="header" slot-scope="scope">
             <el-button size="mini" @click="addHotelPrice(price)" type="primary">Добавить</el-button>
          </template>
          <template slot-scope="scope">
            <el-button @click="removeHotelPrice(price, scope.row)" type="small" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
        <el-table-column width="150" label="Номер">
          <template slot-scope="scope">
            <el-select v-model="scope.row.RoomTypeId">
              <el-option v-for="item in roomTypes" :key="item.Id" :value="item.Id" :label="item.Name"></el-option>
             </el-select>
          </template>
        </el-table-column>
        <el-table-column width="150" label="Размещение">
          <template slot-scope="scope">
            <el-select v-model="scope.row.RoomAccomodationId">
              <el-option v-for="item in roomAccomodations" :key="item.Id" :value="item.Id" :label="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="150" label="Тип питания">
          <template slot-scope="scope">
            <el-select v-model="scope.row.BoardingId">
              <el-option v-for="item in boarings" :key="item.Id" :value="item.Id" :label="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="150" label="Себестоимость">
          <template slot-scope="scope">
            <el-input v-model="scope.row.Netto"></el-input>
          </template>
        </el-table-column>
        <el-table-column width="150" label="Для агента">
          <template slot-scope="scope">
            <el-input v-model="scope.row.AgentPrice"></el-input>
          </template>
        </el-table-column>
       <el-table-column width="150" label="Для клиента">
        <template slot-scope="scope">
          <el-input v-model="scope.row.ClientPrice"></el-input>
        </template>
       </el-table-column>
        <el-table-column width="150" label="Квота">
          <template slot-scope="scope">
            <el-input v-model="scope.row.Quota"></el-input>
          </template>
        </el-table-column>
    </el-table>
    </div>
   </el-form>
  </ColGroup>
  </RowSpan>
</template>
<style lang="scss">
.hotel-service-form {
  .checkbox-group {
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    .el-form-item {
      width: 25%;
      margin-bottom:0px
    }
  }
  .price-group{
    display: flex;
    flex-direction: row;
    .el-form-item {
      width: calc(33% - 10px);
      padding: 10px;
      &__label{
        font-weight:500;
      }
    }
  }
}
</style>
